<footer class="theme-footer">
  <div class="footer-wrapper">


    <div class="footer-section">
      <span>© 2026 وزارة الشؤون الاجتماعية جميع الحقوق محفوظة</span>
    </div>

  </div>
</footer>
